var map = {
	"./angbao-bonus-cny.webp": 2498,
	"./angbao-bonus-dewali.webp": 2499,
	"./angbao-bonus-mooncake.webp": 2500,
	"./angbao-bonus-raya.webp": 2501,
	"./angbao-bonus-thaipusam.webp": 2502,
	"./angbao-bonus.webp": 2503,
	"./anni-lucky-draw.webp": 2504,
	"./cny-lucky-draw.webp": 2505,
	"./cny-promo.webp": 2506,
	"./dewali-promo.webp": 2507,
	"./dongzhi-angbao-bonus.webp": 2508,
	"./fifa-logo.webp": 2509,
	"./fifa-prediction.webp": 2510,
	"./fifa-qna.webp": 2511,
	"./uefa-predic.webp": 2512,
	"./welcome-cny-bonus.webp": 2513
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2497;